import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function differentialsCascade() {
    const root = document.querySelector(".home-differentials");
    if (!root) return;

    const pinEl = root.querySelector(".home-differentials__content");
    if (!pinEl) return;

    const list = root.querySelector(".home-differentials__list");
    if (!list) return;

    const cards = Array.from(
        list.querySelectorAll(".home-differentials__item"),
    );
    const total = cards.length;
    if (total <= 1) return;

    const headerEl = document.querySelector(".o-header");

    const mm = gsap.matchMedia();

    mm.add("(min-width: 1280px)", () => {
        const rem = () =>
            parseFloat(getComputedStyle(document.documentElement).fontSize) ||
            16;

        const headerH = () =>
            headerEl ? Math.round(headerEl.getBoundingClientRect().height) : 0;

        // header + 5rem
        const topOffset = () => Math.round(headerH() + 5 * rem());

        // ✅ todos fora da tela, com distância controlada (evita “último rápido”)
        const getStartY = (i) => {
            const vh = window.innerHeight || 800;
            const base = vh * 1.1; // 110% da viewport
            const spacing = vh * 0.35; // espaçamento fixo entre cards
            return Math.round(base + (i - 1) * spacing);
        };

        // aplica posição dos cards com base no "step progress"
        // pSteps vai de 0..(total-1)
        const render = (pSteps) => {
            for (let i = 0; i < total; i++) {
                // item 0 sempre em 0
                if (i === 0) {
                    gsap.set(cards[i], { y: 0 });
                    continue;
                }

                // cada card i começa a entrar quando pSteps >= (i-1)
                // e termina quando pSteps >= i
                const local = pSteps - (i - 1); // 0..1 no trecho do card i
                const t = Math.max(0, Math.min(1, local));

                const startY = getStartY(i);
                const y = startY * (1 - t);

                gsap.set(cards[i], { y });
            }
        };

        // inicial: tudo fora (exceto 0)
        render(0);

        const perStep = () => Math.round(window.innerHeight * 0.9);

        const st = ScrollTrigger.create({
            trigger: pinEl,
            pin: pinEl,
            start: () => `top top+=${topOffset()}`,
            end: () => `+=${perStep() * (total - 1)}`,
            scrub: 0.25, // "smoosh" suave
            anticipatePin: 1,
            invalidateOnRefresh: true,

            onUpdate(self) {
                const pSteps = self.progress * (total - 1);
                render(pSteps);
            },
        });

        // ✅ MUITO importante: quando recarrega no meio/fim,
        // força render do estado correto após o refresh.
        const syncNow = () => {
            const pSteps = st.progress * (total - 1);
            render(pSteps);
        };

        // recalcula em refresh/resize (startY depende de viewport)
        const onRefresh = () => syncNow();
        ScrollTrigger.addEventListener("refresh", onRefresh);

        // se o header muda altura, refresh
        const ro =
            headerEl && "ResizeObserver" in window
                ? new ResizeObserver(() => ScrollTrigger.refresh())
                : null;
        if (ro) ro.observe(headerEl);

        // garante sincronização no load (inclusive quando abre já scrollado)
        requestAnimationFrame(() => {
            ScrollTrigger.refresh();
            syncNow();
        });

        return () => {
            ScrollTrigger.removeEventListener("refresh", onRefresh);
            st.kill();
            if (ro) ro.disconnect();
        };
    });
}
